import React from "react";
import { useTranslation } from "react-i18next";

interface AuditLogActionBadgeProps {
  action: "create" | "update" | "delete";
  text?: string;
}

const AuditLogActionBadge: React.FC<AuditLogActionBadgeProps> = ({ action, text }) => {
  const { t } = useTranslation();

  const getBadgeStatus = () => {
    switch (action) {
      case "create":
        return "success"; // green
      case "update":
        return "warning"; // yellow
      case "delete":
        return "danger";  // red
      default:
        return "secondary";
    }
  };

  const getDefaultText = () => {
    switch (action) {
      case "create":
        return t("create");
      case "update":
        return t("update");
      case "delete":
        return t("delete");
      default:
        return t("unknown");
    }
  };

  return (
    <span className={`badge badge-soft-${getBadgeStatus()} d-inline-flex align-items-center`}>
      <i className="ti ti-circle-filled fs-5 me-1"></i>
      {text || getDefaultText()}
    </span>
  );
};

export default AuditLogActionBadge;
